import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { addEventPersonnelBulkInsert, addEventPersonnelQuickInsert, getEventPersonnels, updateEventPersonnel } from "../../services/eventPersonnelServices";
import { getEventSuppliers } from "../../services/eventSupplierServices";
import * as XLSX from "xlsx";
import { notification } from "../../helpers/notification";

export const AccreditedList = (props) => {
    const [personnelList, setPersonnelList] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [oldPersonnelList, setOldPersonnelList] = useState([]);
    const [supplierList, setSupplierList] = useState([]);
    const [open, setOpen] = useState(false);
    const [openExcel, setOpenExcel] = useState(false);
    const [excelData, setExcelData] = useState([]);
    const [changePersonnel, setChangePersonnel] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [accreditedFilter, setAccreditedFilter] = useState("all");
    const [personnelTypeFilter, setPersonnelTypeFilter] = useState("all");
    const [currentPage, setCurrentPage] = useState(1);
    const [changeFormValues, setChangeFormValues] = useState({ personnelType: "" });
    const [quickFormValues, setQuickFormValues] = useState({
        supplierUniqueKey: "",
        name: "",
        surname: "",
        identityNumber: "",
        oggNumber: "",
        oggExpireDate: "",
        bankName: "",
        iban: "",
        day: "",
        month: "",
        year: "",
        personnelType: "",
        isRetired: "",
    });
    const fileInputRef = useRef(null);
    const pageSize = 50;

    const onClose = () => {
        setOpen(false);
    };

    const getSupplierList = (callback) => {
        if (supplierList.length == 0) {
            getEventSuppliers().then((suppliers) => {
                setSupplierList(suppliers.items.sort((a, b) => a.name.localeCompare(b.name)));
                callback();
            });
        } else {
            callback();
        }
    };

    const savePersonnelForm = (e) => {
        e.preventDefault();
        if (!selectedRowKeys || selectedRowKeys.length == 0) {
            notification.error({
                message: "Lütfen görevini değiştirmek istediğiniz personelleri seçiniz.",
            });
            return;
        }
        if (!changeFormValues.personnelType) {
            notification.error({
                message: "Lütfen görev seçiniz.",
            });
            return;
        }

        let personnelKeys = [];
        selectedRowKeys.forEach((i) => {
            personnelKeys.push(oldPersonnelList[i].personnelUniqueKey);
        });

        for (const i in personnelKeys) {
            var promise = new Promise((resolve, reject) => {
                updateEventPersonnel({
                    uniqueKey: personnelKeys[i],
                    personnelType: changeFormValues.personnelType,
                })
                    .then(() => {
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    });
            });
            var as = promise;
        }

        notification.success({
            message: "Personellerin görevleri başarıyla değiştirildi.",
        });

        setChangePersonnel(false);
        getData();
    };

    const saveForm = (e) => {
        e.preventDefault();
        const form = { ...quickFormValues };

        form.birthDate = moment(form.year + "-" + form.month + "-" + form.day, "YYYY-MM-DD");

        if (form.birthDate) form.birthDate = form.birthDate.format();

        if (form.oggExpireDate) {
            form.oggExpireDate = moment(form.oggExpireDate).format();
        } else {
            form.oggExpireDate = null;
        }

        form.isRetired = form.isRetired == "1";
        form.eventUniqueKey = props.uniqueKey;
        addEventPersonnelQuickInsert(form)
            .then((result) => {
                notification.success({
                    message: "Personel başarıyla eklendi.",
                });
            })
            .catch((message) => {
                notification.error({
                    message: "Bir hata oluştu, bilgileri kontrol edip tekrar deneyiniz",
                });
            });
    };

    const applyFilters = (search, accredited, personnelType, source) => {
        let result = source;

        if (accredited !== "all") {
            const wantAccredited = accredited === "yes";
            result = result.filter((w) => !!w.isAccredited === wantAccredited);
        }

        if (personnelType !== "all") {
            result = result.filter((w) => String(w.personnelType) === String(personnelType));
        }

        if (search) {
            const upper = search.toLocaleUpperCase();
            const lower = search.toLocaleLowerCase();
            const searchKey = (key) => key.toLocaleUpperCase().indexOf(upper) > -1 || key.toLocaleLowerCase().indexOf(lower) > -1;
            result = result.filter(
                (w) =>
                    searchKey(w.name) ||
                    searchKey(w.surname) ||
                    searchKey(w.identityNumber) ||
                    w.oggNumber == search ||
                    searchKey(w.eventSupplierName)
            );
        }

        return result;
    };

    const handleSearch = (value) => {
        setSearchTerm(value);
        setPersonnelList(applyFilters(value, accreditedFilter, personnelTypeFilter, oldPersonnelList));
        setCurrentPage(1);
    };

    const handleAccreditedFilterChange = (value) => {
        setAccreditedFilter(value);
        setPersonnelList(applyFilters(searchTerm, value, personnelTypeFilter, oldPersonnelList));
        setCurrentPage(1);
    };

    const handlePersonnelTypeFilterChange = (value) => {
        setPersonnelTypeFilter(value);
        setPersonnelList(applyFilters(searchTerm, accreditedFilter, value, oldPersonnelList));
        setCurrentPage(1);
    };


    const changePersonnelStatus = (uniqueKey, status) => {
        updateEventPersonnel({
            uniqueKey: uniqueKey,
            isAccredited: status,
        }).then(() => {
            let newList = [];
            oldPersonnelList.forEach((item) => {
                if (item.uniqueKey == uniqueKey) item.isAccredited = status;
                newList.push(item);
            });
            setOldPersonnelList(newList);
            setPersonnelList(applyFilters(searchTerm, accreditedFilter, personnelTypeFilter, newList));
        });
    };

    const getData = () => {
        getEventPersonnels(props.uniqueKey).then((result) => {
            result.items.forEach((f, i) => {
                f["key"] = i;
            });
            setPersonnelList(applyFilters(searchTerm, accreditedFilter, personnelTypeFilter, result.items));
            setOldPersonnelList(result.items);
        });
    };

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const toggleSelectAll = () => {
        if (selectedRowKeys.length === personnelList.length) {
            setSelectedRowKeys([]);
        } else {
            setSelectedRowKeys(personnelList.map((_, i) => i));
        }
    };

    const toggleSelectRow = (index) => {
        if (selectedRowKeys.includes(index)) {
            setSelectedRowKeys(selectedRowKeys.filter((k) => k !== index));
        } else {
            setSelectedRowKeys([...selectedRowKeys, index]);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    const totalPages = Math.ceil(personnelList.length / pageSize);
    const paginatedData = personnelList.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    const renderAccreditedCards = () => {
        if (!personnelList || personnelList.length === 0) {
            return <div className="mobile-empty-text">⚠ Tedarikçilerden bu etkinlik için henüz bir personel eklenmemiş.</div>;
        }
        return personnelList.map((record) => (
            <div key={record.key} className={`modal-personnel-card ${record.isAttended ? "attended" : ""}`}>
                <div className="modal-card-header">
                    <div className="modal-card-no">{record.index || record.key + 1}</div>
                    <div className="modal-card-name">{record.name} {record.surname}</div>
                    <div className="modal-card-type">
                        {(record.personnelType == 1 ? "Amir" : record.personnelType == 3 ? "Özel Güvenlik Sorumlusu" : "ÖG") + (record.isRetired ? " (Emekli)" : "")} · {record.eventSupplierName || ""}
                    </div>
                </div>
                <div className="modal-card-body">
                    <div className="modal-card-row">
                        <span className="info-label">TC Kimlik</span>
                        <span className="info-value">{record.identityNumber}</span>
                    </div>
                    <div className="modal-card-row">
                        <span className="info-label">ÖGG No</span>
                        <span className="info-value">{record.oggNumber || "-"}</span>
                    </div>
                    <div className="modal-card-row">
                        <span className="info-label">ÖGG Bitiş</span>
                        <span className="info-value">{record.oggExpireDate ? moment(record.oggExpireDate).format("DD.MM.YYYY") : "-"}</span>
                    </div>
                    <div className="modal-card-row">
                        <span className="info-label">D.Tarihi</span>
                        <span className="info-value">{record.birthDate ? moment(record.birthDate).format("DD.MM.YYYY") : "-"}</span>
                    </div>
                    <div className="modal-card-row">
                        <span className="info-label">Akredite</span>
                        <span className="info-value">
                            <button
                                type="button"
                                onClick={() => changePersonnelStatus(record.uniqueKey, !record.isAccredited)}
                                className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${record.isAccredited ? "bg-green-500" : "bg-gray-300"}`}
                            >
                                <span
                                    className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform ${record.isAccredited ? "translate-x-[18px]" : "translate-x-[2px]"}`}
                                />
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        ));
    };

    const copyItems = () => {
        let copyText = "";
        selectedRowKeys.forEach((i) => {
            copyText += oldPersonnelList[i].identityNumber + "\n";
        });

        var copyTextInput = document.getElementById("copyText");
        copyTextInput.value = copyText;
        copyTextInput.select();
        copyTextInput.setSelectionRange(0, 999999);
        document.execCommand("copy");
        notification.success({
            message: selectedRowKeys.length + " Adet TC Kopyalandı",
        });
    };

    const openQuickPersonnel = () => {
        getSupplierList(() => {
            setOpen(true);
        });
    };

    const handleFileUploadOk = () => {
        addEventPersonnelBulkInsert({
            eventUniqueKey: props.uniqueKey,
            data: excelData,
        })
            .then((result) => {
                notification.success({
                    message: "Personel başarıyla eklendi.",
                });
                setOpenExcel(false);
                getData();
            })
            .catch((message) => {
                notification.error({
                    message: "Bir hata oluştu, bilgileri kontrol edip tekrar deneyiniz",
                });
            });
    };

    const excelExport = (type) => {
        getEventPersonnels(props.uniqueKey, false, "excel", type, "", true).then((result) => {
            const url = window.URL.createObjectURL(new Blob([result]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Etkinlik Personel Listesi.xlsx");
            document.body.appendChild(link);
            link.click();
            return;
        });
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1, raw: false });

            if (rows.length === 0) return;

            const headers = rows[0].map((h) => String(h || "").trim());

            const json = rows.slice(1).map((row) => {
                let obj = {};
                headers.forEach((header, i) => {
                    obj[header] = row[i] !== undefined ? String(row[i]) : "";
                });
                return obj;
            });
            setOpenExcel(true);
            setExcelData(json);
        };

        reader.readAsArrayBuffer(file);
    };

    const handleQuickFormChange = (field, value) => {
        setQuickFormValues((prev) => ({ ...prev, [field]: value }));
    };

    return (
        <>
            <div className="flex flex-wrap gap-2 mb-4">
                <button className="app-btn btn-yellow" onClick={() => copyItems()}>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>
                    <span>Seçili TC Kimlik Numaraları Kopyala</span>
                </button>
                <textarea id="copyText" style={{ position: "absolute", left: -10000 }}></textarea>
                <button className="app-btn btn-blue" onClick={() => openQuickPersonnel()}>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                    <span>Hızlı Personel Kaydet</span>
                </button>
                <button className="app-btn btn-blue" onClick={() => setChangePersonnel(true)}>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" /></svg>
                    <span>Görev Değiştir</span>
                </button>
                <button className="app-btn btn-green" onClick={() => excelExport()}>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                    <span>Excel'e Aktar</span>
                </button>
                <button className="app-btn btn-green" onClick={() => fileInputRef.current.click()}>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5-5m0 0l5 5m-5-5v12" /></svg>
                    <span>Excel Yükle</span>
                </button>
                <input type="file" ref={fileInputRef} style={{ display: "none" }} accept=".xlsx, .xls" onChange={handleFileUpload} />
                <input
                    type="text"
                    placeholder="Ara..."
                    value={searchTerm}
                    onChange={(e) => handleSearch(e.target.value)}
                    className="px-3 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
                <select
                    value={accreditedFilter}
                    onChange={(e) => handleAccreditedFilterChange(e.target.value)}
                    className="px-3 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                >
                    <option value="all">Tümü</option>
                    <option value="yes">Akredite</option>
                    <option value="no">Akredite Değil</option>
                </select>
                <select
                    value={personnelTypeFilter}
                    onChange={(e) => handlePersonnelTypeFilterChange(e.target.value)}
                    className="px-3 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                >
                    <option value="all">Tüm Görevler</option>
                    <option value="1">Amir</option>
                    <option value="2">Güvenlik Görevlisi</option>
                    <option value="3">Özel Güvenlik Sorumlusu</option>
                </select>
            </div>
            <div className="mobile-tab-cards">
                {renderAccreditedCards()}
            </div>
            <div className="desktop-tab-table">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
                        <thead className="bg-gray-50 dark:bg-gray-800">
                            <tr>
                                <th className="px-3 py-2 w-10">
                                    <input
                                        type="checkbox"
                                        checked={selectedRowKeys.length === personnelList.length && personnelList.length > 0}
                                        onChange={toggleSelectAll}
                                        className="rounded border-gray-300"
                                    />
                                </th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">#</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Adı</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Soyadı</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">TC Kimlik</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">ÖGG Numarası</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">D.Tarihi</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Görevi</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Şirket</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Akredite</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                            {paginatedData.length === 0 ? (
                                <tr>
                                    <td colSpan={10} className="px-3 py-8 text-center text-gray-500 dark:text-gray-400">
                                        ⚠ Tedarikçilerden bu etkinlik için henüz bir personel eklenmemiş.
                                    </td>
                                </tr>
                            ) : paginatedData.map((record) => (
                                <tr key={record.key} className="hover:bg-gray-50 dark:hover:bg-gray-700">
                                    <td className="px-3 py-2">
                                        <input
                                            type="checkbox"
                                            checked={selectedRowKeys.includes(record.key)}
                                            onChange={() => toggleSelectRow(record.key)}
                                            className="rounded border-gray-300"
                                        />
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap">{record.index || record.key + 1}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">{record.name}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">{record.surname}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">{record.identityNumber}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">
                                        <div className="inline-flex items-center gap-1.5">
                                            <span>{record.oggNumber || "-"}</span>
                                            {record.oggExpireDate && (
                                                <span
                                                    className="relative group inline-flex items-center cursor-pointer text-blue-500 hover:text-blue-600"
                                                    title={`ÖGG Bitiş Tarihi: ${moment(record.oggExpireDate).format("DD.MM.YYYY")}`}
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                    </svg>
                                                    <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 hidden group-hover:flex px-2 py-1 bg-gray-900 text-white text-xs rounded shadow-lg whitespace-nowrap z-50 pointer-events-none">
                                                        Bitiş: {moment(record.oggExpireDate).format("DD.MM.YYYY")}
                                                    </span>
                                                </span>
                                            )}
                                        </div>
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap">{record.birthDate ? moment(record.birthDate).format("DD.MM.YYYY") : "-"}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">
                                        {(record.personnelType == 1 ? "Amir" : record.personnelType == 3 ? "Özel Güvenlik Sorumlusu" : "Özel Güvenlik") + (record.isRetired ? " (Emekli)" : "")}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap">{record.eventSupplierName}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">
                                        <button
                                            type="button"
                                            onClick={() => changePersonnelStatus(record.uniqueKey, !record.isAccredited)}
                                            className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${record.isAccredited ? "bg-green-500" : "bg-gray-300"}`}
                                        >
                                            <span
                                                className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform ${record.isAccredited ? "translate-x-[18px]" : "translate-x-[2px]"}`}
                                            />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {totalPages > 1 && (
                    <div className="flex items-center justify-between px-4 py-3 border-t border-gray-200 dark:border-gray-700">
                        <span className="text-sm text-gray-700 dark:text-gray-300">Toplam {personnelList.length} Kayıt Bulunuyor</span>
                        <div className="flex items-center gap-2">
                            <button
                                onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                                disabled={currentPage === 1}
                                className="px-3 py-1 text-sm border border-gray-300 rounded disabled:opacity-50 hover:bg-gray-50 dark:hover:bg-gray-700"
                            >
                                Önceki
                            </button>
                            <span className="text-sm text-gray-700 dark:text-gray-300">{currentPage} / {totalPages}</span>
                            <button
                                onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                                disabled={currentPage === totalPages}
                                className="px-3 py-1 text-sm border border-gray-300 rounded disabled:opacity-50 hover:bg-gray-50 dark:hover:bg-gray-700"
                            >
                                Sonraki
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {changePersonnel && (
                <div className="fixed inset-0 z-50">
                    <div className="fixed inset-0 bg-black bg-opacity-50" onClick={() => setChangePersonnel(false)}></div>
                    <div className="fixed right-0 top-0 h-full w-full max-w-2xl bg-white dark:bg-gray-900 shadow-xl overflow-y-auto">
                        <div className="flex items-center justify-between p-4 border-b">
                            <h3 className="text-lg font-semibold">Personellerin Görevini Değiştir</h3>
                            <button onClick={() => setChangePersonnel(false)} className="text-gray-400 hover:text-gray-600">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div className="p-6">
                            <form onSubmit={savePersonnelForm}>
                                <div className="mb-4">
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Görev</label>
                                    <select
                                        value={changeFormValues.personnelType}
                                        onChange={(e) => setChangeFormValues({ personnelType: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    >
                                        <option value="">Seçiniz</option>
                                        <option value={1}>Amir</option>
                                        <option value={2}>Güvenlik Görevlisi</option>
                                        <option value={3}>Özel Güvenlik Sorumlusu</option>
                                    </select>
                                </div>
                                <button type="submit" className="app-btn btn-red">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" /></svg>
                                    <span>Kaydet</span>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {openExcel && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div className="fixed inset-0 bg-black bg-opacity-50" onClick={() => setOpenExcel(false)}></div>
                    <div className="relative bg-white dark:bg-gray-900 rounded-lg shadow-xl max-w-6xl w-full mx-4 max-h-[90vh] flex flex-col">
                        <div className="flex items-center justify-between p-4 border-b">
                            <h3 className="text-lg font-semibold">Excel'den Yüklenen Personeller</h3>
                            <div className="flex items-center gap-3">
                                <button className="app-btn btn-red" onClick={() => handleFileUploadOk()}>Listeyi Sisteme Aktar</button>
                                <button onClick={() => setOpenExcel(false)} className="text-gray-400 hover:text-gray-600">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div className="overflow-auto flex-1 p-4" style={{ maxHeight: "500px" }}>
                            {excelData.length === 0 ? (
                                <div className="text-center text-gray-500 dark:text-gray-400 py-8">⚠ Excel dosyasında kayıt bulunamadı.</div>
                            ) : (
                                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-xs">
                        <thead className="bg-gray-50 dark:bg-gray-800">
                                        <tr>
                                            <th className="px-3 py-2 text-left font-medium text-gray-500 dark:text-gray-400">TC Kimlik</th>
                                            <th className="px-3 py-2 text-left font-medium text-gray-500 dark:text-gray-400">Ad</th>
                                            <th className="px-3 py-2 text-left font-medium text-gray-500 dark:text-gray-400">Soyad</th>
                                            <th className="px-3 py-2 text-left font-medium text-gray-500 dark:text-gray-400">Doğum Tarihi</th>
                                            <th className="px-3 py-2 text-left font-medium text-gray-500 dark:text-gray-400">Emekli mi ?</th>
                                            <th className="px-3 py-2 text-left font-medium text-gray-500 dark:text-gray-400">Görevi</th>
                                            <th className="px-3 py-2 text-left font-medium text-gray-500 dark:text-gray-400">Tedarikçi</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                                        {excelData.map((record, idx) => (
                                            <tr key={idx} className="hover:bg-gray-50 dark:hover:bg-gray-700">
                                                <td className="px-3 py-1.5 whitespace-nowrap">{record.TC}</td>
                                                <td className="px-3 py-1.5 whitespace-nowrap">{record.AD}</td>
                                                <td className="px-3 py-1.5 whitespace-nowrap">{record.SOYAD}</td>
                                                <td className="px-3 py-1.5 whitespace-nowrap">{record.DT ? moment(record.DT).format("DD.MM.YYYY") : ""}</td>
                                                <td className="px-3 py-1.5 whitespace-nowrap">{record.EMEKLI}</td>
                                                <td className="px-3 py-1.5 whitespace-nowrap">{record.GOREV}</td>
                                                <td className="px-3 py-1.5 whitespace-nowrap">{record.TEDARIKCI}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {open && (
            <div className="fixed inset-0 z-50">
                <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onClose}></div>
                <div className="fixed right-0 top-0 h-full w-full max-w-2xl bg-white dark:bg-gray-900 shadow-xl overflow-y-auto">
                    <div className="flex items-center justify-between p-4 border-b">
                        <h3 className="text-lg font-semibold">Hızlı Personel Kaydet</h3>
                        <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <div className="p-6">
                        <form onSubmit={saveForm}>
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Tedarikçi</label>
                                <select
                                    value={quickFormValues.supplierUniqueKey}
                                    onChange={(e) => handleQuickFormChange("supplierUniqueKey", e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                >
                                    <option value="">Seçiniz</option>
                                    {supplierList.map((item) => (
                                        <option key={item.uniqueKey} value={item.uniqueKey}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mb-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Adı</label>
                                    <input
                                        type="text"
                                        placeholder="Adı"
                                        value={quickFormValues.name}
                                        onChange={(e) => handleQuickFormChange("name", e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Soyadı</label>
                                    <input
                                        type="text"
                                        placeholder="Soyadı"
                                        value={quickFormValues.surname}
                                        onChange={(e) => handleQuickFormChange("surname", e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mb-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">TC Kimlik</label>
                                    <input
                                        type="text"
                                        placeholder="TC Kimlik"
                                        value={quickFormValues.identityNumber}
                                        onChange={(e) => handleQuickFormChange("identityNumber", e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">ÖGG Numarası</label>
                                    <input
                                        type="text"
                                        placeholder="ÖGG Numarası"
                                        value={quickFormValues.oggNumber}
                                        onChange={(e) => handleQuickFormChange("oggNumber", e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mb-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Banka Adı</label>
                                    <input
                                        type="text"
                                        placeholder="Banka Adı"
                                        value={quickFormValues.bankName}
                                        onChange={(e) => handleQuickFormChange("bankName", e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">IBAN</label>
                                    <input
                                        type="text"
                                        placeholder="IBAN"
                                        value={quickFormValues.iban}
                                        onChange={(e) => handleQuickFormChange("iban", e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    />
                                </div>
                            </div>
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">ÖGG Bitiş Tarihi</label>
                                <input
                                    type="date"
                                    value={quickFormValues.oggExpireDate}
                                    onChange={(e) => handleQuickFormChange("oggExpireDate", e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                />
                            </div>
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Doğum Tarihi</label>
                                <div className="grid grid-cols-3 gap-4">
                                    <select
                                        value={quickFormValues.day}
                                        onChange={(e) => handleQuickFormChange("day", e.target.value)}
                                        className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    >
                                        <option value="">Gün</option>
                                        {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                                            <option key={day} value={day < 10 ? `0${day}` : `${day}`}>{day}</option>
                                        ))}
                                    </select>
                                    <select
                                        value={quickFormValues.month}
                                        onChange={(e) => handleQuickFormChange("month", e.target.value)}
                                        className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    >
                                        <option value="">Ay</option>
                                        {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                                            <option key={month} value={month < 10 ? `0${month}` : `${month}`}>{month}</option>
                                        ))}
                                    </select>
                                    <select
                                        value={quickFormValues.year}
                                        onChange={(e) => handleQuickFormChange("year", e.target.value)}
                                        className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    >
                                        <option value="">Yıl</option>
                                        {Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - 17 - i).map((year) => (
                                            <option key={year} value={year}>{year}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mb-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Görevi</label>
                                    <select
                                        value={quickFormValues.personnelType}
                                        onChange={(e) => handleQuickFormChange("personnelType", e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    >
                                        <option value="">Seçiniz</option>
                                        <option value={1}>Amir</option>
                                        <option value={2}>Güvenlik Görevlisi</option>
                                        <option value={3}>Özel Güvenlik Sorumlusu</option>
                                    </select>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Emekli mi ?</label>
                                    <select
                                        value={quickFormValues.isRetired}
                                        onChange={(e) => handleQuickFormChange("isRetired", e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    >
                                        <option value="">Seçiniz</option>
                                        <option value="0">Hayır</option>
                                        <option value="1">Evet</option>
                                    </select>
                                </div>
                            </div>
                            <button type="submit" className="app-btn btn-red">
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" /></svg>
                                <span>Kaydet</span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            )}
        </>
    );
};
